import { END_OF_DAY_MINUTES } from '../config/schedule-session.config';

// Sessions never cross midnight (spec Assumptions), so the shifted end caps there.
export function getShiftedEndTime(oldStart: number, newStart: number, end: number): number {
    return Math.min(end + (newStart - oldStart), END_OF_DAY_MINUTES);
}
